<template>
  <b-tag
    class="tag-view"
    :data-e2e="TagViewCypressAttribute.views.TAG"
    :type="type"
    :size="size"
    :rounded="rounded"
    :icon="icon"
    :icon-pack="iconPack"
    :icon-type="iconType"
    @close="onClose"
    @click="onClick"
  >
    <slot />
  </b-tag>
</template>
<script>
import { TagViewCypressAttribute } from '@/modules/core/ui/constants/TagViewCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TagView',
  emits: ['close', 'click'],
  props: {
    type: {
      type: String
    },
    size: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    iconPack: {
      type: String,
      default: 'cls'
    },
    iconType: {
      type: String
    }
  },
  static: {
    TagViewCypressAttribute
  },
  methods: {
    onClose(...args) {
      this.$emit('close', ...args);
    },
    onClick(...args) {
      this.$emit('click', ...args);
    }
  }
};
</script>
<style scoped>
.tag-view {
  height: var(--ce-24px);
  min-height: var(--ce-24px);
  font-size: var(--ce-12px);
  line-height: var(--ce-16px);
  padding: var(--ce-4px) var(--ce-8px);
  border-radius: var(--ce-radius);
  gap: var(--ce-4px);
}

.tag-view.is-rounded {
  border-radius: var(--ce-radius-rounded);
}

.tag-view.is-medium {
  height: var(--ce-32px);
  min-height: var(--ce-32px);
  font-size: var(--ce-16px);
  line-height: var(--ce-24px);
}

.tag-view :deep(.icon) {
  width: var(--ce-8px);
  height: var(--ce-8px);
  font-size: var(--ce-8px);
}

.tag-view.is-medium :deep(.icon) {
  width: var(--ce-12px);
  height: var(--ce-12px);
  font-size: var(--ce-12px);
}
</style>
